import * as React from "react";

export const useSetState = (initialState) => {
    const [state, setState] = React.useState(initialState);

    const getState = async () => {
        let state: unknown;

        await setState((currentState) => {
            state = currentState;
            return currentState;
        });

        return state;
    };

    return [state, setState, getState];
};
